import { css } from '@emotion/react';
import { CollaboratorCard } from './CollaboratorCard';
import { SectionTitle } from '@/components/general/SectionTitle';
import { getScreen } from '@/styles/media-query';
import { withPrefix } from 'gatsby';

export type CollaboratorSectionProps = {
  className?: string;
};

export const CollaboratorSection: React.FC<CollaboratorSectionProps> = ({
  className,
}) => {
  return (
    <section
      id="reality"
      css={css`
        display: none;
      
        padding: 80px 0 88px;
        background: #F0FCFB;

        @media ${getScreen('pc')} {
          padding: 120px 0 232px;
        }
      `}
      className={className}
    >
      <SectionTitle
        css={css`
          padding-right: 20px;
          padding-left: 20px;
        `}
        en="COLLABORATOR"
      >
        支援者の声
      </SectionTitle>
      <div
        css={css`
          display: flex;
          flex-direction: column;
          gap: 40px;
          margin: auto;
          margin-top: 40px;
          max-width: 1065px;

          @media ${getScreen('pc')} {
            margin-top: 80px;
          }
          @media ${getScreen('pc', '未満')} {
            padding-right: 20px;
            padding-left: 20px;
          }
        `}
      >
        <CollaboratorCard
          index={1}
          name={
            <>
              田中 太郎
            </>
          }
          subText={
            <>
              ○○VC
            </>
          }
          comment={
            <>
              ダミーダミーダミーダミーダミーダミーダミーダミーダミーダミーダミーダミーダミーダミーダミーダミーダミーダミーダミーダミーダミーダミーダミーダミーダミーダミーダミーダミーダミーダミーダミーダミーダミーダミーダミーダミーダミーダミーダミーダミーダミーダミーダミーダミーダミーダミーダミーダミーダミーダミーダミーダミーダミーダミーダミーダミーダミーダミーダミーダミーダミーダミーダミーダミーダミーダミーダミーダミーダミーダミー
            </>
          }
          spImage={{
            src: withPrefix('/images/top/collaborator-1.png'),
            width: 270,
            height: 205,
          }}
          pcImage={{
            src: withPrefix('/images/top/collaborator-1.png'),
            width: 270,
            height: 205,
          }}
        />
        <CollaboratorCard
          index={2}
          name={
            <>
              田中 太郎
            </>
          }
          subText={
            <>
              ○○VC
            </>
          }
          comment={
            <>
              ダミーダミーダミーダミーダミーダミーダミーダミーダミーダミーダミーダミーダミーダミーダミーダミーダミーダミーダミーダミーダミーダミーダミーダミーダミーダミーダミーダミーダミーダミーダミーダミーダミーダミーダミーダミーダミーダミーダミーダミーダミーダミーダミーダミーダミーダミーダミーダミーダミーダミーダミーダミーダミーダミーダミーダミーダミーダミーダミーダミーダミーダミーダミーダミーダミーダミーダミーダミーダミーダミー
            </>
          }
          spImage={{
            src: withPrefix('/images/top/collaborator-1.png'),
            width: 270,
            height: 205,
          }}
          pcImage={{
            src: withPrefix('/images/top/collaborator-1.png'),
            width: 270,
            height: 205,
          }}
        />
      </div>
    </section>
  );
};
